import { IClass } from "./Class";
import { IUser } from "./User";

export enum PaymentStatus {
  NEW = "NEW",
  HOLD = "HOLD",
  APPROVED = "APPROVED",
  PAID = "PAID",
  REJECTED = "REJECTED",
  PENDING_INSTRUCTOR = "PENDING_INSTRUCTOR",
  PENDING_STUDENT = "PENDING_STUDENT",
  REFUNDED = "REFUNDED",
  CANCELLED = "CANCELLED",
  DELETED = "DELETED",
  UNPAID = "UNPAID",
}

export interface IRequest {
  user: IUser;
  class: IClass;
  instructor: IUser;
  timeSlot: any;
  style?: string;
  group?: boolean;
  quantity?: number;
  online?: boolean;
  comment?: string;
  address?: string;
  location?: any;
  status: PaymentStatus;
  paymentId?: string;
  transferId?: string;
  price?: number;
  credits?: number;
  userName?: string;
  instructorName?: string;
}
